<app-product-nav></app-product-nav>
<div class="peer-groups">
  <div id="tour-groups-create" routerLink="/peer-comparison/groups/create" class="create-peer-group">
    <div class="create-peer-group__text">Create Custom Peer Group</div>
    <svg class="icon create-peer-group__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M232 344V280H168C154.7 280 144 269.3 144 256C144 242.7 154.7 232 168 232H232V168C232 154.7 242.7 144 256 144C269.3 144 280 154.7 280 168V232H344C357.3 232 368 242.7 368 256C368 269.3 357.3 280 344 280H280V344C280 357.3 269.3 368 256 368C242.7 368 232 357.3 232 344zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z" /></svg>
  </div>
  @for (group of groups(); track group.groupId) {
  <div class="peer" [ngClass]="{ 'peer--open': group.isOpen }">
    <div class="peer__sticky-wrapper">
      <div class="peer__title">
        @if (group.groupType != 10) {
        <img class="peer__icon-lh" src="/assets/img/icon-lh.svg" width="48" height="48">
        }
        {{ group.name }}
        <span class="peer__bank-count">{{ group.institutionCount }}</span>
        @if (group.groupType == 10 && (numAdded == 0 && numRemoved == 0)) {
        <span (click)="renameGroup(group.groupId)" class="peer__remove-group">Rename Group</span>
        <span (click)="deleteGroup(group.groupId)" class="peer__remove-group">Delete Group</span>
        }
        <span id="tour-groups-view" (click)="toggleView(group)" class="peer__toggle">View{{ group.groupType == 10 ? '/Edit' : '' }} Credit Unions <svg class="icon peer__toggle-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z" /></svg></span>
      </div>
      @if (group.groupType == 10) {
      <div class="peer__add">
        <span class="peer__add-icon"><svg class="icon peer__add-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 368C269.3 368 280 357.3 280 344V280H344C357.3 280 368 269.3 368 256C368 242.7 357.3 232 344 232H280V168C280 154.7 269.3 144 256 144C242.7 144 232 154.7 232 168V232H168C154.7 232 144 242.7 144 256C144 269.3 154.7 280 168 280H232V344C232 357.3 242.7 368 256 368z" /></svg></span>
        <app-institution-autocomplete placeholder="Start typing to add a new credit union to this group"
                                      class="peer__add-input"
                                      [onlyActive]="true"
                                      [institutionType]="institution().institutionType"
                                      (selectInstitutionEvent)="onSelectInstitution($event, group.groupId)">
        </app-institution-autocomplete>
      </div>
      }
      <div class="peer__table">
        <table>
          <thead>
            <tr>
              <th class="col-sort" [ngClass]="{ 'col-sort--ascend': group.sortColumn == 'name' && group.sortDir == 'asc', 'col-sort--decend': group.sortColumn == 'name' && group.sortDir == 'desc' }" (click)="onSort(group, 'name')">Name</th>
              <th class="col-sort" [ngClass]="{ 'col-sort--ascend': group.sortColumn == 'creditUnionType' && group.sortDir == 'asc', 'col-sort--decend': group.sortColumn == 'creditUnionType' && group.sortDir == 'desc' }" (click)="onSort(group, 'creditUnionType')">Type</th>
              <th class="col-sort" [ngClass]="{ 'col-sort--ascend': group.sortColumn == 'totalAssetsQe' && group.sortDir == 'asc', 'col-sort--decend': group.sortColumn == 'totalAssetsQe' && group.sortDir == 'desc' }" (click)="onSort(group, 'totalAssetsQe')">Assets</th>
              <th class="col-sort" [ngClass]="{ 'col-sort--ascend': group.sortColumn == 'annualAssetGrowth' && group.sortDir == 'asc', 'col-sort--decend': group.sortColumn == 'annualAssetGrowth' && group.sortDir == 'desc' }" (click)="onSort(group, 'annualAssetGrowth')">Asset Growth (3yr Avg)</th>
              <th class="col-sort" [ngClass]="{ 'col-sort--ascend': group.sortColumn == 'roeQe' && group.sortDir == 'asc', 'col-sort--decend': group.sortColumn == 'roeQe' && group.sortDir == 'desc' }" (click)="onSort(group, 'roeQe')">Return on Equity</th>
              <th class="col-sort" [ngClass]="{ 'col-sort--ascend': group.sortColumn == 'roaQe' && group.sortDir == 'asc', 'col-sort--decend': group.sortColumn == 'roaQe' && group.sortDir == 'desc' }" (click)="onSort(group, 'roaQe')">Return On Assets</th>
              <th class="col-sort" [ngClass]="{ 'col-sort--ascend': group.sortColumn == 'netIntMarginQe' && group.sortDir == 'asc', 'col-sort--decend': group.sortColumn == 'netIntMarginQe' && group.sortDir == 'desc' }" (click)="onSort(group, 'netIntMarginQe')">Net Interest Margin</th>
              <th class="col-sort" [ngClass]="{ 'col-sort--ascend': group.sortColumn == 'texasRatioQe' && group.sortDir == 'asc', 'col-sort--decend': group.sortColumn == 'texasRatioQe' && group.sortDir == 'desc' }" (click)="onSort(group, 'texasRatioQe')">Texas Ratio</th>
              <th class="col-sort" [ngClass]="{ 'col-sort--ascend': group.sortColumn == 'nonIntIncToTotalAssetsQe' && group.sortDir == 'asc', 'col-sort--decend': group.sortColumn == 'nonIntIncToTotalAssetsQe' && group.sortDir == 'desc' }" (click)="onSort(group, 'nonIntInctoTotalAssetsQe')">Non Interest Income to Total Assets</th>
            </tr>
          </thead>
          <tbody>
            <tr class="peer-table-user-bank">
              <td>{{ clientProfile?.label }}</td>
              <td>{{ clientProfile?.creditUnionType }}</td>
              <td>{{ usdDisplay(clientProfile?.totalAssetsQe) }}</td>
              <td>{{ pctDisplay(clientProfile?.annualAssetGrowth) }}</td>
              <td>{{ pctDisplay(clientProfile?.roeQe) }}</td>
              <td>{{ pctDisplay(clientProfile?.roaQe) }}</td>
              <td>{{ pctDisplay(clientProfile?.netIntMarginQe) }}</td>
              <td>{{ pctDisplay(clientProfile?.texasRatioQe) }}</td>
              <td>{{ pctDisplay(clientProfile?.nonIntIncToTotalAssetsQe) }}</td>
            </tr>
            @for (institution of group.institutionProfiles | paginate: { id: group.groupId, itemsPerPage: 25, currentPage: group.page }; track institution.iid) {
            <tr [ngClass]="{ 'bank-removed': institution.isRemoved, 'bank-added': institution.isAdded }">
              @if (group.groupType != 10) {
              <td>
                @if (institution.websiteAddress && institution.websiteAddress.length > 0) {
                <a href="{{ fixUrl(institution.websiteAddress) }}" target="_blank">{{ institution.name }} ({{ institution.city }}, {{ institution.state }})</a>
                } @else {
                <span>{{ institution.name }} ({{ institution.city }}, {{ institution.state }})</span>
                }
              </td>
              } @else {
              <td>
                <div class="peer__bank-name">
                  @if (institution.websiteAddress && institution.websiteAddress.length > 0) {
                  <a href="{{ fixUrl(institution.websiteAddress) }}" target="_blank">{{ institution.name }} ({{ institution.city }}, {{ institution.state }})</a>
                  } @else {
                  <span>{{ institution.name }} ({{ institution.city }}, {{ institution.state }})</span>
                  }
                  <span (click)="removeInstitution(group.groupId, institution.iid)" class="peer__bank-name-remove">Remove</span>
                </div>
              </td>
              }
              <td>{{ institution.creditUnionType }}</td>
              <td>{{ usdDisplay(institution.totalAssetsQe) }}</td>
              <td>{{ pctDisplay(institution.annualAssetGrowth) }}</td>
              <td>{{ pctDisplay(institution.roeQe) }}</td>
              <td>{{ pctDisplay(institution.roaQe) }}</td>
              <td>{{ pctDisplay(institution.netIntMarginQe) }}</td>
              <td>{{ pctDisplay(institution.texasRatioQe) }}</td>
              <td>{{ pctDisplay(institution.nonIntIncToTotalAssetsQe) }}</td>
            </tr>
            }
          </tbody>
        </table>
        <div class="pagination">
          <pagination-controls id="{{ group.groupId}}" (pageChange)="group.page = $event"></pagination-controls>
        </div>
      </div>
    </div>
    <div class="peer__desc">
      @if (group.description) {
      <p>
        {{ group.description }}
      </p>
      }
      @if (group.criteria) {
      <p>
        <strong>Selection criteria: </strong>{{ group.criteria }}
      </p>
      }
    </div>
    @if (group.isOpen && group.institutionProfiles.length == 0 && loading) {
    <div class="loading-update">
      <div class="loading-update__loader loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
    }
  </div>
  }
  <div routerLink="/peer-comparison/groups/create" class="create-peer-group">
    <div class="create-peer-group__text">Create Custom Peer Group</div>
    <svg class="icon create-peer-group__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M232 344V280H168C154.7 280 144 269.3 144 256C144 242.7 154.7 232 168 232H232V168C232 154.7 242.7 144 256 144C269.3 144 280 154.7 280 168V232H344C357.3 232 368 242.7 368 256C368 269.3 357.3 280 344 280H280V344C280 357.3 269.3 368 256 368C242.7 368 232 357.3 232 344zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z" /></svg>
  </div>
</div>

<div class="peer-actions" [ngClass]="{ 'peer-actions--open': isDirty }">
  <div class="peer-actions__summary">
    @if (numAdded > 0) {
    <span class="peer-actions__count peer-actions__count--added">{{ numAdded }}</span> {{ numAdded > 0 ? 'Credit Unions Added' : '' }}
    }
    @if (numRemoved > 0) {
    <span class="peer-actions__count peer-actions__count--removed">{{ numRemoved }}</span> {{ numRemoved > 0 ? 'Credit Unions Removed' : '' }}
    }
  </div>
  <button (click)="discardChanges()" class="peer-actions__option peer-actions__option--discard" type="button">Discard Changes</button>
  <button (click)="saveChanges()" class="peer-actions__option peer-actions__option--save" type="button">Save Changes</button>
</div>

<div #dialog></div>
